import * as React from "react";
import { Modal, ModalBody, ModalHeader } from 'reactstrap';


class YesNoComponent extends React.Component {
    constructor(props) {
        super(props);
    }

    closeModal = () => {
        const { modalNoFunction, NoParameter } = this.props;
        if (modalNoFunction) {
            modalNoFunction(NoParameter);
        }
    }

    render() {
        const { showModal, modalText, modalYesFunction, modalNoFunction, YesParameter, NoParameter, className, title } = this.props;
        const containerClassName = "verify-modal" + (className ? " " + className : "");

        return (
            showModal &&
            <Modal className={containerClassName} isOpen={showModal} centered>
                {title && <ModalHeader>{title}<button type="button" className="btn btn-icon-only" onClick={this.closeModal}><span className="icon-close" /></button></ModalHeader>}
                <ModalBody>
                    <div className="row">
                        <div className="col-12">
                            <p dangerouslySetInnerHTML={{ __html: modalText }} ></p>
                            <div className="row link-container">
                                <div className="col-6 link-left"><button type="button" className="btn text-btn" onClick={() => modalYesFunction(YesParameter)}>YES</button></div>
                                <div className="col-6 link-right"><button type="button" className="btn text-btn" onClick={() => modalNoFunction(NoParameter)}>NO</button></div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        );
    }


}


export default YesNoComponent;